import React, { useEffect, useState } from 'react';
import { Modal, Tab, OverlayTrigger, Container, Popover, PopoverContent } from 'react-bootstrap';
import IpaffsModalHeader from './IpaffsModalHeader';
import ConditionalWrapper from '../Util/ConditionalWrapper';
import { getButtonStyle } from './utils';
import IpaffsModalTabDetailedView from './IpaffsModalTabDetailedView';
import IpaffsModalTabConsolidatedView from './IpaffsModalTabConsolidatedView';
const tabs = [{ title: 'Detailed' }, { title: 'Consolidated' }];

const IpaffsModalReadOnly = ({ show, onHide, certificateCount, data, isConsolidatedTab = false }) => {
  const [currentTab, setCurrentTab] = useState(isConsolidatedTab ? 1 : 0);
  const [consolidatedData, setConsolidatedData] = useState([]);

  useEffect(() => {
    if (data?.length) {
      const categoryByItemId = data.reduce((map, cat) => {
        map[cat.id] = cat;
        return map;
      }, {});

      const consolidatedMap = data.reduce((acc, item) => {
        const cat = categoryByItemId[item.id];
        const key = [item.Origin, cat?.categoryOption || 'blank'].join('|');

        const grossMass = parseFloat(item?.['Gross mass (kg)'] ?? 0);
        const validGrossMass = isNaN(grossMass) ? 0 : parseFloat(grossMass.toFixed(2));

        if (!acc[key]) {
          acc[key] = {
            hsCode: item.hsCode,
            hsCodes: [item.hsCode],
            origin: item.Origin,
            riskCategory: cat?.categoryOption ?? '',
            grossWeight: validGrossMass,
            itemIds: [item.id],
            consolidatedIpaffs: cat?.consolidatedIpaffs ?? '',
            ipaffsHsCode: item.ipaffsHSCode,
            ipaffsHSCodes: [item.ipaffsHSCode],
          };
        } else {
          acc[key].grossWeight += validGrossMass;
          acc[key].itemIds.push(item.itemId);

          if (item.hsCode && !acc[key].hsCodes.includes(item.hsCode)) {
            acc[key].hsCodes.push(item.hsCode);
          }
          if (item.ipaffsHSCode && !acc[key].ipaffsHSCodes.includes(item.ipaffsHSCode)) {
            acc[key].ipaffsHSCodes.push(item.ipaffsHSCode);
          }
        }

        return acc;
      }, {});
      const returnData = Object.values(consolidatedMap).filter((e) => e.riskCategory);
      setConsolidatedData(returnData);
    }
  }, [data]);

  return (
    <Modal show={show} onHide={onHide} centered animation={false} dialogClassName="modal-90w">
      <IpaffsModalHeader certificateCount={certificateCount} readOnly={true} />
      <Modal.Body>
        <Container fluid className="pt-4 mt-3">
          <Container fluid className="">
            <Tab.Container activeKey={currentTab}>
              <div className="px-3 pt-0">
                <div className="tab-header w-100 ipaffs-modal-tabs">
                  {tabs.map((tab, idx) => {
                    return (
                      <React.Fragment key={idx}>
                        <ConditionalWrapper
                          condition={false}
                          wrapper={(children) => (
                            <OverlayTrigger
                              placement="top"
                              trigger={['hover', 'focus']}
                              overlay={
                                <Popover style={{ minWidth: '5rem' }}>
                                  <PopoverContent>
                                    <p>Please fill all the risk categories to view the consolidated view</p>
                                  </PopoverContent>
                                </Popover>
                              }
                            >
                              {children}
                            </OverlayTrigger>
                          )}
                        >
                          <button
                            className={'tab-control text-eoriblue active ipaffs-modal-tab'}
                            style={getButtonStyle(currentTab === idx)}
                            onClick={() => setCurrentTab(idx)}
                          >
                            <span style={getButtonStyle(currentTab === idx)}>{tab.title}</span>
                          </button>
                        </ConditionalWrapper>
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>

              <Tab.Content style={{ paddingTop: '0' }}>
                <Tab.Pane eventKey={0} style={{ paddingTop: '0' }}>
                  <IpaffsModalTabDetailedView readOnly={true} data={data} />
                </Tab.Pane>
                <Tab.Pane eventKey={1}>
                  <IpaffsModalTabConsolidatedView readOnly={true} data={consolidatedData} />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Container>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default IpaffsModalReadOnly;
